import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center pt-20 pb-12 px-6 overflow-hidden" data-id="element-78">
      {/* Background subtle glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-79"></div>

      <div className="max-w-5xl mx-auto w-full flex flex-col lg:flex-row items-center gap-12 z-10" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex-1 text-center lg:text-left" data-id="element-81">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-cream" data-id="element-82">
            El Tesoro de Dubái en Tu Cocina:{' '}
            <span className="text-gold block mt-2" data-id="element-83">
              El Método Maestro para el Pastel Viral de $100
            </span>
          </h1>
          <p className="font-sans text-lg md:text-xl text-cream-muted mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-84">
            Aprende a recrear el pastel de chocolate y pistacho más deseado del
            mundo usando ingredientes de tu supermercado local y ahorrando un
            80% del costo.
          </p>

          <motion.a href="#pricing" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block bg-gold hover:bg-gold-light text-dark font-sans font-semibold text-lg px-8 py-4 rounded-sm transition-colors duration-300 shadow-[0_0_20px_rgba(197,165,90,0.3)]" data-id="element-85">
            ¡QUIERO MI GUÍA AHORA!
          </motion.a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="flex-1 w-full max-w-md lg:max-w-full relative" data-id="element-86">
          <div className="absolute inset-0 bg-gradient-to-tr from-gold/20 to-transparent rounded-lg blur-xl transform translate-y-4 translate-x-4" data-id="element-87"></div>
          <img src="https://cdn.magicpatterns.com/uploads/ft1QYiMkj3CG58gVaJSJJD/El_tesoro_de_dubai_.png" alt="El Tesoro de Dubái - Pastel de Chocolate y Pistacho" className="w-full h-auto rounded-lg shadow-2xl relative z-10 border border-white/10" data-id="element-88" />
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-gold/50" data-id="element-89">
        <ChevronDown size={32} data-id="element-90" />
      </motion.div>
    </section>;
}